import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

const Whychooseusa = () => {
  return (
    <div className="whychooseusa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              <span>Why Choose</span> TekRevol as Your Unity3D Game Development
              Company?
            </h2>
          </Col>
        </Row>
        <Row className="h-100 choose_padd">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <p>
              At TekRevol, we stand out as your preferred choice for Unity3D
              game development, and here's why:
            </p>
            <p>
              Our team of dedicated Unity game developers brings your ideas to
              life with precision and expertise. We specialize in the intricate
              world of Unity games development, ensuring your vision transforms
              seamlessly into captivating and engaging experiences.
            </p>
            <p>
              What sets us apart is our commitment to understanding your unique
              needs. As a Unity 3D game development company, we tailor our
              services to match the specific requirements of your project,
              whether it's mobile game development or creating immersive
              experiences for PC and consoles.
            </p>

            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Discuss Your Project!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
            <StaticImage
              src="../../images/services-usa/game/Why-Choose.webp"
              alt="tekrevol_android"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={910}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Whychooseusa;
